export default __webpack_public_path__ + "static/media/fallback-meta-img.830f0d16.svg";